module.exports = __webpack_public_path__ + "img/share.a1001294.svg";